import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';
import "./ProductsPage.css";

const ProductsPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  // Get the api from auth context
  const { api } = useAuth();

  // Fetch all items
  useEffect(() => {
    const fetchItems = async () => {
      setLoading(true);
      try {
        const response = await api.get('/api/getAllItems');
        const data = response.data.items.filter(item => item.name !== 'CustomAdRequest');
        setItems(data);
        setFilteredItems(data);
          const uniqueCategories = [...new Set(
          data
            .map(item => item.creativeType && item.creativeType.name)
            .filter(Boolean)
        )];
        setCategories(uniqueCategories);
        setLoading(false);
      } catch (err) {
        setError('Failed to load products. Please try again later.');
        setLoading(false);
      }
    };

    fetchItems();
  }, [api]);

  // Filter items based on search term and selected category
  useEffect(() => {
     let filtered = [...items];

    if (searchTerm.trim() !== '') {
      filtered = filtered.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedCategory !== 'All') {
      filtered = filtered.filter(item =>
        item.creativeType && item.creativeType.name === selectedCategory
      );
    }

    setFilteredItems(filtered);
  }, [searchTerm, selectedCategory, items]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  
  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  if (loading) return <div className="loading">Loading products...</div>;
  if (error) return <div className="error">{error}</div>;

  const groupedItems = filteredItems.reduce((acc, item) => {
    const category = item.creativeType && item.creativeType.name ? item.creativeType.name : 'Other';
    if (!acc[category]) acc[category] = [];
    acc[category].push(item);
    return acc;
  }, {});

  return (
    <div className="products-container">
      <h1>Our Products</h1>

      {/* Search section */}
      <div className="search-container">
        <input
          id="searchInput"
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search products"
          className="search-input"
        />
      </div>

           {/* Category filter pills */}
      {categories.length > 0 && (
        <div className="filter-buttons">
          <button
            className={`filter-pill ${selectedCategory === 'All' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('All')}
          >
            All
          </button>
          {categories.map(cat => (
            <button
              key={cat}
              className={`filter-pill ${selectedCategory === cat ? 'active' : ''}`}
              onClick={() => handleCategoryClick(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      )}

      {/* Products list grouped by category */}
      {Object.keys(groupedItems).length === 0 ? (
        <p>No products found matching your search.</p>
      ) : (
        Object.keys(groupedItems).map(category => (
          <div key={category} className="category-section">
            <div className="category-header">
              <h2>{category}</h2>
              <div className="category-line" />
            </div>
            <div className="products-list">
              {groupedItems[category].length === 0 ? (
                <p>No products found in this category.</p>
              ) : (
                groupedItems[category].map(item => (
                  <div key={item.id} className="product-item">
                    <Link to={`/product/${item.id}`} className="product-title">
                      {item.image && (
                        <div className="product-image-container">
                          <img src={item.image} alt={item.name} className="product-image" />
                        </div>
                      )}
                      <h2>{item.name}</h2>
                    </Link>
                  </div>
                ))
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ProductsPage;
